import * as Yup from 'yup'
import { TAG } from './fields'

export const validationSchema = Yup.object({
  [TAG]: Yup.string().required('This field can not be empty')
})
